import { FieldSettingsModel } from '../../common-models/field-settings.model';
import { FieldType, MeasurementUnits } from '../../../../shared/enums';
import { RangeFieldValidator } from '../../../../shared/zoneiqui/field-validators';
import { ITableFieldsConfiguration } from 'src/app/interfaces/tables/table-fields-configuration.interface';

function calibrationBonusFieldsFactory() {
    return [
        new FieldSettingsModel('LevelBonus', FieldType.NUMBER, MeasurementUnits.LEVELS, {
            validators: [new RangeFieldValidator(-1)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('HeightBonus', FieldType.NUMBER, MeasurementUnits.FEET, {
            validators: [new RangeFieldValidator(-1)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('FLRBonus', FieldType.NUMBER, MeasurementUnits.NONE, {
            validators: [new RangeFieldValidator(0, 100)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('BrownfieldRedevelopment', FieldType.NUMBER, MeasurementUnits.NONE, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('ParkingReductionBonus', FieldType.NUMBER, MeasurementUnits.PERCENT, {
            validators: [new RangeFieldValidator(0, 100)],
            isLongMeasurementSection: true
        })
    ];
}

export default { fieldsFactory: calibrationBonusFieldsFactory } as ITableFieldsConfiguration;
